import { Modal } from 'flowbite-react';
import React, { useState } from 'react'
import { FaHandsHelping, FaWhatsapp } from "react-icons/fa";

export default function FAB() {
    const [openModal, setOpenModal] = useState(false);

    return (
        <div>
            <button className='fixed bottom-2 right-2 bg-yellow-300 p-2 rounded-full text-black flex z-[60]' onClick={() => setOpenModal(true)}><FaHandsHelping size={24} className='mr-2' />¿Necesitas ayuda?</button>
            <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
                <Modal.Header className="bg-black text-white flex justify-center items-center">
                    <img src="/identity/MONOLOGO.png" className="h-6 sm:h-9" alt="Monoticket" />
                </Modal.Header>

                <Modal.Body className="bg-[#0f0e17] text-white text-center">
                    <span className='text-2xl'>¿Tienes problemas para realizar la compra de tu entrada?</span>
                    <a
                        href="https://wa.me/5216141163947?text=¡Hola!%20Necesito%20soporte%20con%20la%20p%C3%A1gina%20de%20Monoticket"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg shadow-md transition mt-4"
                    >
                        <FaWhatsapp size={20} />
                        Contáctanos por WhatsApp
                    </a>
                </Modal.Body>
            </Modal>
        </div>
    )
}
